import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tw-flex" };
const _hoisted_2 = { class: "tw-px-4 md:tw-px-6 tw-mx-auto tw-max-w-screen-2xl sm:tw-w-[calc(100%-280px)] tw-w-full lg:tw-pt-0 tw-pt-3 sm:tw-mt-0 tw-mt-5" };
const _hoisted_3 = {
    key: 0,
    class: "tw-relative tw-w-[70%] tw-h-[calc(100vh-180px)] tw-mt-6"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 0,
    ref: "scrollContainer",
    class: "tw-max-h-[calc(100vh-180px)] tw-overflow-auto"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CasinoLiveComponentSidebar = _resolveComponent("CasinoLiveComponentSidebar");
    const _component_CasinoLiveHeader = _resolveComponent("CasinoLiveHeader");
    const _component_CardTitle = _resolveComponent("CardTitle");
    const _component_CardContent = _resolveComponent("CardContent");
    const _component_Card = _resolveComponent("Card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CasinoLiveComponentSidebar, { liveGameCategories: $props.liveGameCategories }, null, 8, ["liveGameCategories"]),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CasinoLiveHeader, {
                games: $props.games,
                isLoading: $props.isLoading
            }, null, 8, ["games", "isLoading"]),
            _createElementVNode("div", {
                class: _normalizeClass($setup.gameUrl ? 'tw-flex tw-w-full tw-gap-4' : 'tw-w-full')
            }, [
                ($setup.gameUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("button", {
                            class: "tw-absolute tw-top-2 tw-right-2 tw-bg-red-500 tw-text-white tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-font-bold",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => ($setup.closeGame && $setup.closeGame(...args)))
                        }, " Close "),
                        _createElementVNode("iframe", {
                            src: $setup.gameUrl,
                            frameborder: "0",
                            class: "tw-w-full tw-h-full"
                        }, null, 8, _hoisted_4)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass($setup.gameUrl ? 'tw-w-[30%]' : 'tw-w-full')
                }, [
                    _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-col-span-full tw-xl:col-span-4 tw-w-full tw-bg-transparent" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_CardTitle, { class: "tw-mb-4 tw-text-lg" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($props.selectedLiveCategory?.name || "All"), 1)
                                ]),
                                _: 1
                            }),
                            ($props.games.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_CardContent, {
                                        class: _normalizeClass($setup.gameUrl ? 'scroller tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4' : 'scroller tw-grid tw-grid-cols-3 lg:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-5 tw-gap-4')
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.games, (game) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: game.id
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "tw-flex tw-items-center tw-gap-4 2xl:tw-gap-3 tw-rounded tw-cursor-pointer tw-w-full tw-h-full",
                                                        onClick: ($event) => ($setup.handleGameClick(game))
                                                    }, [
                                                        _createElementVNode("img", {
                                                            src: game.gameIcon ? game.gameIcon : 'https://contents.static-slotcity.com/game_pic/bng/197.png',
                                                            alt: game.name,
                                                            class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                        }, null, 8, _hoisted_7)
                                                    ], 8, _hoisted_6)
                                                ]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    }, 8, ["class"]),
                                    ($props.isLoading)
                                        ? (_openBlock(), _createBlock(_component_CardContent, {
                                            key: 0,
                                            class: _normalizeClass($setup.gameUrl ? 'tw-mt-6 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4' : 'tw-grid tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-6 tw-gap-5 tw-mt-6')
                                        }, {
                                            default: _withCtx(() => [
                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
                                                    return _createElementVNode("div", {
                                                        key: 'skeleton-' + index,
                                                        class: "tw-flex tw-items-center tw-gap-4 tw-rounded tw-animate-pulse"
                                                    }, _cache[1] || (_cache[1] = [
                                                        _createElementVNode("div", { class: "tw-bg-gray-300 tw-rounded-md md:tw-h-32 tw-h-[70px] tw-w-full" }, null, -1)
                                                    ]));
                                                }), 64))
                                            ]),
                                            _: 1
                                        }, 8, ["class"]))
                                        : _createCommentVNode("", true)
                                ], 512))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ], 2)
            ], 2)
        ])
    ]));
}
